/**
 * OverlayConfigContext.tsx
 *
 * React context that provides the overlay configuration to the entire
 * JamCam app.  Changes are auto-persisted to localStorage and
 * synchronised across tabs via storage events.
 */

import {
  type OverlayConfig,
  overlayConfigStore,
} from '../config/overlayConfig';
import {
  createPersistedConfigContext,
  type PersistedConfigContextValue,
} from './persistedConfig';

const overlayContext = createPersistedConfigContext(overlayConfigStore);

export const OverlayConfigProvider = overlayContext.Provider;

export function useOverlayConfig(): PersistedConfigContextValue<OverlayConfig> {
  return overlayContext.useConfig();
}
